<app-loader [isLoading]="isLoading"></app-loader>
<div class="modal-heading">
    <div class="close-button invisible"></div>
    <div class="header-text">All Submitted Bills</div>
    <div class="close-button" (click)="closeDialog()">
        <mat-icon class="close-icon">close</mat-icon>
    </div>
</div>

<div class="the_container">
    <div class="table-container">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>
                        <span>Bill Amount</span>
                    </th>
                    <th>
                        <span>Bill Date</span>
                    </th>
                    <th>
                        <span>Submitted By</span>
                    </th>
                    <th>
                        <span>Comments</span>
                    </th>
                </tr>
            </thead>
            <tbody class="table-body">
                @for(row of bills;track row){
                <tr>
                    <td data-label="advance-amount" >
                        <span>{{formatIndianCurrency(row.bill_amount)}}</span>
                    </td>
                    <td data-label="advance-date">
                        <span>{{row.bill_receive_date}}</span>
                    </td>
                    <td data-label="desc">
                        <span>{{row.bill_submitted_by}}</span>
                    </td>
                    <td data-label="desc">
                        <span>{{row.comments}}</span>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>